import React, { useState, useEffect } from "react";
import {
  fetchProgrammes,
  fetchFortNoxPrograms,
} from "../../actions/programmeActions";
import { fetchClasses } from "../../actions/classActions";
import { Button, Row, Col, Input, Table, Card, CardTitle } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditProgramme from "../../components/Modal/EditProgramme";
import CreateProgramme from "../../components/Modal/CreateProgramme";
import { API_BASE_URL } from "../../constants/api.constants";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import axios from "../../services/api/api";
import { useSelector, useDispatch } from "react-redux";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

function Programmes(props) {
  const [school] = useState(
    props.location.state
      ? props.location.state.school
      : JSON.parse(localStorage.getItem("school"))
  );
  const [createProgrammeModal, setCreateProgrammeModal] = useState(false);
  const [overrideLoader, setOverrideLoader] = useState(false);
  const [programmes, setProgrammes] = useState([]);
  const [programmeToUpdate, setProgrammeToUpdate] = useState(null);
  const [programmeToRemove, setProgrammeToRemove] = useState(null);
  const [displayConfirmDialog, setDisplayConfirmDialog] = useState(false);
  const [programmeEditModal, setProgrammeEditModal] = useState(false);

  const dispatch = useDispatch();

  const programmesReducer = useSelector((state) => state.programmeReducer);
  const classesReducer = useSelector((state) => state.classReducer);
  const fortNoxPrograms = useSelector((state) => state.fortnoxProgramReducer);

  useEffect(() => {
    localStorage.setItem("school", JSON.stringify(school));
    dispatch(fetchProgrammes(school.id));
    dispatch(fetchClasses(school.id));
    dispatch(fetchFortNoxPrograms());
  }, [dispatch, school]);

  useEffect(() => {
    if (!programmesReducer.loading) {
      setProgrammes(programmesReducer.result);
    }
  }, [programmesReducer]);

  const loadProgrammes = () => {
    setOverrideLoader(true);
    dispatch(fetchProgrammes(school.id)).then(() => {
      setProgrammes(programmesReducer.result);
    });
  };

  const toggleProgrammeModal = () => {
    setCreateProgrammeModal(!createProgrammeModal);
  };

  const handleSetProgrammeToUpdate = (programme) => {
    setProgrammeToUpdate(programme);
    setProgrammeEditModal(true);
  };

  const toggleEditModal = () => {
    setProgrammeToUpdate(null);
    setProgrammeEditModal(!programmeEditModal);
  };

  const toggleCreateProgrammeModal = () => {
    setCreateProgrammeModal(!createProgrammeModal);
  };

  const toggleConfirmDialog = (p) => {
    setProgrammeToRemove(p);
    setDisplayConfirmDialog(!displayConfirmDialog);
  };

  const reloadProgrammes = () => {
    dispatch(fetchProgrammes(school.id)).then(() => {
      setProgrammes(programmesReducer.result);
    });
  };

  const getprogrammeToRemove = () => {
    if (programmeToRemove) {
      let c = programmes.find((c) => c.id === programmeToRemove.id);
      if (c) return c.name;
    }
    return "Okänd";
  };

  const handleFilterSearch = (event) => {
    setProgrammes(
      programmesReducer.result.filter((p) => {
        if (p.name.toLowerCase().indexOf(event.target.value) !== -1) {
          return p;
        }
        return null;
      })
    );
  };

  const deleteProgramme = () => {
    axios
      .delete(`${API_BASE_URL}/programme/${programmeToRemove.id}`)
      .then(() => {
        reloadProgrammes();
        setProgrammeToRemove(null);
        setDisplayConfirmDialog(false);
        toast.success(
          <FormattedMessage id="Views.Admin.DeleteProgrammeFromSchool.Success" />,
          TOAST_CONFIG
        );
      })
      .catch((err) => {
        toast.error(err.response.data, TOAST_CONFIG);
      });
  };

  if (programmesReducer.loading && overrideLoader === false) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  var mappedProgrammes = programmes.map((p, id) => {
    return (
      <tr key={id}>
        <td>
          <Button color="link" onClick={() => handleSetProgrammeToUpdate(p)}>
            {p.name}
          </Button>
        </td>
        <td>{p.classes.length}</td>
        <td>
          <Button
            onClick={(e) => {
              toggleConfirmDialog(p);
              e.stopPropagation();
            }}
            size="sm"
            color="danger"
            outline
            className="float-end"
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <div className="animated fadeIn">
      <Row>
        <Col lg="12">
          <Card body>
            <CardTitle>Program - {school.name}</CardTitle>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card body>
            <Row className="search-row">
              <Col className="col-4">
                <Input
                  className="search-input"
                  placeholder="Sök program"
                  onChange={(data) => handleFilterSearch(data)}
                />
              </Col>
              <Col className="offset-6 col-2">
                <Button
                  className="float-end"
                  color="primary"
                  outline
                  onClick={() => {
                    toggleProgrammeModal();
                  }}
                >
                  <FontAwesomeIcon icon="plus" />
                </Button>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <Table hover className="school-table clickable">
                  <thead>
                    <tr>
                      <th>Namn</th>
                      <th>Antal klasser</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>{mappedProgrammes}</tbody>
                </Table>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <CreateProgramme
        toggle={toggleCreateProgrammeModal}
        isOpen={createProgrammeModal}
        onComplete={loadProgrammes}
        school={school}
        fortNoxPrograms={fortNoxPrograms.result}
      />

      <EditProgramme
        toggle={toggleEditModal}
        isOpen={programmeEditModal}
        onComplete={loadProgrammes}
        programme={programmeToUpdate}
        classes={classesReducer.result}
      />

      <ConfirmDialog
        isOpen={displayConfirmDialog}
        danger={true}
        title="Ta bort lärare"
        message={
          <div>
            <p>
              Är du säker på att du vill ta bort läraren '
              <strong>{getprogrammeToRemove()}</strong>'?
            </p>
            <p>
              <em>Det här valet går inte att ångra.</em>
            </p>
          </div>
        }
        toggle={toggleConfirmDialog}
        onProceed={deleteProgramme}
      />
    </div>
  );
}

export default Programmes;
